import React, {Fragment, useContext} from "react";
import {useParams} from 'react-router-dom';
import {GlobalContext} from "../admin-frame/AdminFrame";
import {ApiUtility} from "../common/ApiUtility";
import {Constants} from "../common/Constants";
import {ActivityScope} from "../../types/ActivityScope";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {useModelUpdateEngine} from "../common/hooks/useModelUpdateEngine";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {ActivityScopeForm} from "./ActivityScopeForm";

type UpdateActivityScopePageRouteParams = {
    activityScopeId: string;
}

export let UpdateActivityScopePage = function () {
    const context = useContext(GlobalContext);
    const params = useParams<UpdateActivityScopePageRouteParams>();
    const scopesListPath = `/${Constants.routes.settings.pathSegment}/activity-scopes`;

    function fetchActivityScope(activityScopeId: string) {
        return ApiUtility.getActivityScopes().then(function (activityScopesList: ActivityScope[]) {
            return activityScopesList.find(function (activityScope) {
                return '' + activityScope.id === '' + activityScopeId;
            });
        });
    }

    const modelUpdateEngine = useModelUpdateEngine(
        fetchActivityScope,
        ApiUtility.updateActivityScope,
        '' + params.activityScopeId,
        'scope',
        () => context.navigator.navigateTo(scopesListPath),
        {}
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelUpdateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ConditionalRenderer if={modelUpdateEngine.dataStore.data().model} renderer={() => (
                <ActivityScopeForm
                    save={modelUpdateEngine.updateModel}
                    activityScope={modelUpdateEngine.dataStore.data().model}
                    isNew={false}
                />
            )}/>
        </Fragment>
    );
};
